import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';

import { fullName } from '../../../../Utils/Format/Names';
import { formatAddress } from '../../../../Utils/Format/Address';
import EmailIcon from '../../../../Components/CustomIcons/EmailIcon';
import TrashIcon from '../../../../Components/CustomIcons/IcTrash';
import PencilIcon from '../../../../Components/CustomIcons/IcPencil';

import SimpleDivider from '../../../../Components/Dividers/SimpleDivider';
import { Company } from '../../../../Configs/general';

const ContractItemGDG = props => {
  const { contract, removeContract, openEditDialog } = props;
  const classes = useStyles();

  const handleEditDialog = React.useCallback(() => {
    openEditDialog(contract);
  }, [contract, openEditDialog]);

  const handleRemoveContract = React.useCallback(() => {
    removeContract(contract);
  }, [contract, removeContract]);

  return (
    <>
      <Grid container direction="row" className={classes.contractItem}>
        <Grid item xs={3} className={classes.textContainer}>
          <Typography className={classes.label}>
            {Company.contractConjugation.capitalized.singular.associate}
          </Typography>
          <Typography className={classes.text}>
            {`${contract.alias} - ${contract.id}`}
          </Typography>
        </Grid>
        <Grid item xs={7} className={classes.textContainer}>
          <Typography className={classes.label}>Nombre del titular</Typography>
          <Typography className={`${classes.text} ${classes.capitalizeText}`}>
            {fullName(contract.holder, 'name', 'lastName', true)}
          </Typography>
        </Grid>
        <Grid item xs={2} className={classes.actionsContainer}>
          <IconButton
            aria-label={`editar ${Company.contractConjugation.regular.singular.main}`}
            onClick={handleEditDialog}
            className={classes.icon}
          >
            <PencilIcon size={20} />
          </IconButton>
          <IconButton
            aria-label={`desasociar ${Company.contractConjugation.regular.singular.main}`}
            onClick={handleRemoveContract}
            className={classes.icon}
          >
            <TrashIcon size={20} />
          </IconButton>
        </Grid>

        <Grid item xs={12} className={classes.addressContainer}>
          <div>
            <Typography className={clsx(classes.label, classes.labelMargin)}>
              Dirección del predio
            </Typography>
            <Typography className={`${classes.text} ${classes.capitalizeText}`}>
              {formatAddress(contract, true)}
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} className={classes.addressContainer}>
          {contract.sendInvoice && (
            <Grid
              container
              className={classes.activeChannelsContainer}
              wrap="nowrap"
            >
              <EmailIcon size={16} className={classes.noShrink} />
              <Typography className={classes.activeChannelsText}>
                Envío de factura vía correo electrónico mensual programado.
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
      <SimpleDivider withoutMargin={true} className={classes.dividerLast} />
    </>
  );
};

const useStyles = makeStyles(theme => ({
  contractItem: {
    padding: theme.spacing(3)
  },
  actionsContainer: {
    textAlign: 'end'
  },
  textContainer: {
    paddingLeft: theme.spacing(),
    paddingRight: theme.spacing()
  },
  addressContainer: {
    paddingLeft: theme.spacing(),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  pointsContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 15
  },
  pointsText: {
    fontSize: 16,
    fontWeight: 'bold',
    marginLeft: theme.spacing()
  },
  label: {
    fontSize: 11,
    fontWeight: 500,
    color: theme.palette.text.greyDark
  },
  labelMargin: {
    marginTop: 15
  },
  text: {
    fontSize: 16,
    fontWeight: 500,
    color: theme.palette.text.default
  },
  capitalizeText: {
    textTransform: 'capitalize'
  },
  activeChannelsContainer: {
    alignItems: 'center',
    marginTop: 12
  },
  activeChannelsText: {
    fontSize: 12,
    color: theme.palette.text.greyDark,
    marginLeft: theme.spacing()
  },
  icon: {
    padding: theme.spacing(),
    marginRight: theme.spacing()
  },
  noShrink: {
    flexShrink: 0
  },
  dividerLast: {
    '&:last-child': {
      display: 'none'
    }
  }
}));

export default ContractItemGDG;
